import { ENDPOINTS } from './enums';

/**
 * Function that fetches all data needed for intercom
 */
export const fetchIntercomUserData = (userData, customerData, keycloak, isTrial) => {
	const userDataIntercom = {
		app_id: process.env.INTERCOM_APP_ID,
		name: userData.givenName,
		email: userData.email,
		company: customerData.name,
		created_at: new Date().getTime(),
		canonical_name: customerData.canonical_name,
		is_self_service: customerData.is_self_service,
		user_hash: undefined,
	};

	// For intercom, if the user is from self service (isTrial) we need to fetch some user data
	if (isTrial) {
		// Fetches number of workflows on the organization. Even if there are more than 50
		// we don't need to know that value specifically for the end goal.
		const getWorkflows = API.GET(`${ENDPOINTS.WORKFLOWS}/${customerData.id}/workflows`, {
			headers: {
				Authorization: `Bearer ${keycloak.token}`,
				'customer-id': customerData.id,
			},
			params: {
				page_size: 50,
			},
		})
			.then((res) => {
				userDataIntercom.number_pipelines = res.data?.results?.length;
			})
			.catch((error) => {
				Sentry.captureException(error);
			});

		// Fetches number of users on the organization
		const getUsers = API.GET(ENDPOINTS.USERS, {
			headers: {
				Authorization: `Bearer ${keycloak.token}`,
			},
		})
			.then((res) => {
				userDataIntercom.number_users = res.data?.data?.length;
			})
			.catch((error) => {
				Sentry.captureException(error);
			});

		Promise.allSettled([getWorkflows, getUsers]);
	}

	return userDataIntercom;
};
